import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getOrganizationStats,
  OrganizationStatsResponse,
} from "@/services/organizationsApi";
import { B2bOrgsStatCard } from "./b2b-orgs-stat-card";
import { B2bMrrCard } from "./b2b-mrr-card";
import { B2bSeatsCard } from "./b2b-seats-card";
import { B2bAtRiskCard } from "./b2b-at-risk-card";
import { B2bTierPieCard } from "./b2b-tier-pie-card";
import { B2bRolesBarCard } from "./b2b-roles-bar-card";
import { B2bSeatOccupancyBarCard } from "./b2b-seat-occupancy-bar-card";
import { B2bActivityFeedCard } from "./b2b-activity-feed-card";

/**
 * Section "Comptes entreprise (B2B)" du dashboard admin.
 *
 * Fait UN SEUL fetch `GET /api/organizations/stats` et passe le résultat en
 * props aux cartes (évite N appels au même endpoint). Le feed d'activité a son
 * propre fetch (endpoint distinct `/activity`).
 */
export function B2bStatsSection() {
  const navigate = useNavigate();
  const [stats, setStats] = useState<OrganizationStatsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError(null);
      try {
        setStats(await getOrganizationStats(navigate));
      } catch (e) {
        setError(e instanceof Error ? e.message : "Erreur inconnue");
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  const cardProps = { stats, loading, error };

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-sm font-semibold text-muted-foreground">
        Comptes entreprise (B2B)
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <B2bOrgsStatCard {...cardProps} />
        <B2bMrrCard {...cardProps} />
        <B2bSeatsCard {...cardProps} />
        <B2bAtRiskCard {...cardProps} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <B2bTierPieCard {...cardProps} />
        <B2bRolesBarCard {...cardProps} />
        <B2bSeatOccupancyBarCard {...cardProps} />
      </div>
      <B2bActivityFeedCard />
    </div>
  );
}
